import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ToggleEvent {
	isOpen: boolean;
}

@Component({
	selector: 'accordion',
	templateUrl: './accordion.component.html',
	styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent {
	@Input()
	public isOpen = false;

	@Input()
	public title: string;

	@Input()
	public icon: string;

	@Input()
	public tag: string;

	@Output()
	public onToggle: EventEmitter<ToggleEvent> = new EventEmitter<ToggleEvent>();

	public toggleIsOpen(): void {
		this.isOpen = !this.isOpen;

		this.onToggle.emit({
			isOpen: this.isOpen,
		});
	}
}
